"use client"

import { Building } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BuildingIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BuildingIcon = component(Icon)({ as: Building })
